import React from "react";
import { Typography, Card } from "antd";
import styled from "styled-components";
import {
  WifiOutlined,
  BulbOutlined,
  VideoCameraOutlined,
  ScanOutlined,
  EnvironmentOutlined,
  AlertOutlined,
  SwapOutlined,
  BarChartOutlined,
  GlobalOutlined,
  WarningOutlined,
  AimOutlined,
  HistoryOutlined,
  SafetyCertificateOutlined,
  DashboardOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import imagesix from "../../../src/Assests/product/image6.svg";
import imageseven from "../../../src/Assests/product/img7.svg";
import  Icon1 from "../../../src/Assests/product/Icon (1).svg"
import  Icon2 from "../../../src/Assests/product/Icon (2).svg"
import  Icon3 from "../../../src/Assests/product/Icon (3).svg"
import  Icon4 from "../../../src/Assests/product/Icon (4).svg"
import  Container1 from "../../../src/Assests/product/Container (1).svg"
import  Container2 from "../../../src/Assests/product/Container (2).svg"
import  Container3 from "../../../src/Assests/product/Container (3).svg"
import  Container4 from "../../../src/Assests/product/Container (4).svg"

import  Icon11 from "../../../src/Assests/product1/Icon (1).svg"
import  Icon21 from "../../../src/Assests/product1/Icon (2).svg"
import  Icon31 from "../../../src/Assests/product1/Icon (3).svg"
import  Icon41 from "../../../src/Assests/product1/Icon (4).svg"
import  Container11 from "../../../src/Assests/product1/Icon (5).svg"
// import  Container21 from "../../../src/Assests/product/Container (1).svg"
import  Container31 from "../../../src/Assests/product1/Container (2).svg"
import  Container41 from "../../../src/Assests/product1/Container (3).svg"
import  image31 from "../../../src/Assests/product1/image 31 (1).svg"
import  Containerrr from "../../../src/Assests/product/Containerrr (1).svg"

const { Title, Paragraph, Text } = Typography;


const COLORS = {
  green: "#1a7f4e",
  greenDark: "#146341",
  greenSoft: "#e9f5ee",
  ink: "#1f2a24",
  sub: "#6b7a72",
  border: "#e7ebe8",
  imgBg: "#f2f4f3",
  card: "#ffffff",
  page: "#ffffff",
};


const Page = styled.div`
  background: ${COLORS.page};
  padding: 56px 24px 72px;
  font-family: "DM Sans", sans-serif !important;
  color: #7c7878 !important;
`;

const Header = styled.div`
  text-align: center;
  max-width: 640px;
  margin: 0 auto 40px;
`;

const Eyebrow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${COLORS.green};
  background: ${COLORS.greenSoft};
  padding: 4px 12px;
  border-radius: 999px;
  margin-bottom: 14px;
`;

const HeaderTitle = styled(Title)`
  &.ant-typography {
    color: ${COLORS.greenDark};
    font-weight: 700;
    margin-bottom: 10px !important;
    letter-spacing: -0.01em;
  }
`;

const HeaderSubtitle = styled(Paragraph)`
  &.ant-typography {
    color: ${COLORS.sub};
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 0;
  }
`;

const OuterFrame = styled.div`
  max-width: 1040px;
  margin: 0 auto;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ProductCard = styled(Card)`
  border-radius: 12px;
  border: 1px solid ${COLORS.border};
  overflow: hidden;

  .ant-card-body {
    padding: 0;
    display: flex;
    flex-direction: ${(p) => (p.$reverse ? "row-reverse" : "row")};
    min-height: 320px;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }
`;

const ImagePane = styled.div`
  flex: 0 0 42%;
  background: ${COLORS.imgBg};
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  padding: 24px;
  position: relative;

  @media (max-width: 768px) {
    flex: 1 1 auto;
    min-height: 220px;
  }
`;

const ProductImage = styled.img`
  max-width: 100%;
  max-height: 260px;
  width: auto;
  height: auto;
  object-fit: contain;
`;

const ContentPane = styled.div`
  flex: 1 1 58%;
  padding: 32px 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ProductTitle = styled(Title)`
  &.ant-typography {
    color: ${COLORS.ink};
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 8px !important;
  }
`;

const ProductDesc = styled(Paragraph)`
  &.ant-typography {
    color: ${COLORS.sub};
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 20px;
  }
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 10px;
  column-gap: 20px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13.5px;
  color: ${COLORS.ink};

  .anticon {
    flex: none;
    color: ${COLORS.green};
    font-size: 15px;
  }
`;


const dashCamFeatures = [
  { icon: <img src={Container1} alt="Icon5" />
  , label: "AI Driver Monitoring" },
  { icon: <img src={Icon4} alt="Icon4" />, label: "Dual HD Cameras" },
  { icon: <img src={Icon1} alt="Icon1" />  , label: "Fatigue Detection" },
  { icon: <img src={Container4} alt="Icon8" /> , label: "Distraction Detection" },
  { icon:<img src={Icon3} alt="Icon3" /> , label: "Live 4G Remote Surveillance" },
  { icon:<img src={Container3} alt="Icon7" /> , label: "GPS & Speed Tracking" },
  { icon: <img src={Container2} alt="Icon6" />, label: "Night Vision" },
  { icon:<img src={Icon2} alt="Icon2" /> , label: "Automatic Incident Recording" },
];

const fuelSensorFeatures = [
  { icon:<img src={Container31} alt="Icon8" /> , label: "Real-time Fuel Monitoring" },
  { icon: <img src={Icon31} alt="Icon8" />, label: "Fuel Theft Alerts" },
  { icon:<img src={Icon11} alt="Icon8" />, label: "Fill & Drain Detection" },
  { icon:<img src={Container41} alt="Icon8" />, label: "High Accuracy" },
  { icon:<img src={Icon21} alt="Icon8" /> , label: "Fuel Consumption Reports" },
  { icon: <img src={Container11} alt="Icon8" />, label: "Historical Analytics" },
  { icon:<img src={Containerrr} alt="Icon8" /> , label: "GPS Integration" },
  { icon: <img src={Container31} alt="Icon8" /> , label: "Rugged Industrial Design" },
];


function ProductRow({ reverse, image, imageAlt, title, description, features }) {
  return (
    <ProductCard $reverse={reverse}>
      <ImagePane>
        <ProductImage src={image} alt={imageAlt} />
      </ImagePane>
      <ContentPane>
        <ProductTitle level={4}>{title}</ProductTitle>
        <ProductDesc>{description}</ProductDesc>
        <FeatureGrid>
          {features.map((f) => (
            <FeatureItem key={f.label}>
              {f.icon}
              <Text>{f.label}</Text>
            </FeatureItem>
          ))}
        </FeatureGrid>
      </ContentPane>
    </ProductCard>
  );
}

export default function FleetHardwareSection() {
  return (
    <Page>
      <Header>
        {/* <Eyebrow>
          <SafetyCertificateOutlined />
          TrackRight Hardware
        </Eyebrow> */}
        <HeaderTitle level={2}>
          Smart Hardware for Smarter Fleet Operations
        </HeaderTitle>
        <HeaderSubtitle>
          Enhance your fleet with intelligent IoT devices that improve
          safety, reduce operational costs, and provide real-time
          visibility. Every device integrates seamlessly with TrackRight.
        </HeaderSubtitle>
      </Header>

      <OuterFrame>
        <ProductRow
          image={image31}
          imageAlt="AI Dash Camera"
          title="AI Dash Camera"
          description="Monitor every journey with AI-powered dash cameras that improve driver safety and provide real-time video intelligence."
          features={dashCamFeatures}
        />

        <ProductRow
          reverse
          image={imageseven}
          imageAlt="Fuel Level Sensor"
          title="Fuel Level Sensor"
          description="Gain complete visibility into your fleet's fuel usage with a high-precision fuel monitoring solution."
          features={fuelSensorFeatures}
        />
      </OuterFrame>
    </Page>
  );
}